<template>
  <v-app>
    <v-content>
      <Header />
        <transition name="fade">
          <router-view></router-view>          
        </transition>
      <Footer />
    </v-content>
  </v-app>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'

export default {
  name: 'App',
  components: {
    Header, Footer
  },
  data () {
    return {
      //
    }
  }
}
</script>

<style>
  .fade-enter {
    opacity: 0;
  }
  .fade-enter-active {
    transition: 1s;
  }
  .fade-leave-active {
    transition: 1s;
    opacity: 0;
  }
</style>
